import {progress} from "./feature.progress.svelte.js";
import {booker} from "../booker/feature.booker.svelte.js";
import {booking} from "../booking/feature.booking.svelte.js";
import {ENTRY_TYPE_BADENKAART, ENTRY_DURATION_DAY, ENTRY_DURATION_2_HOUR, UI_ID_PANEL10_RESTYPE, UI_ID_PANEL14_RESSUBTYPE, UI_ID_PANEL17_PEOPLE, UI_ID_PANEL20_CALENDAR, UI_ID_PANEL30_TIME, UI_ID_PANEL40_PACKAGEDEAL, UI_ID_PANEL50_TREATMENTS, UI_ID_PANEL60_FORM, UI_ID_PANEL70_PAY, ENVIRONMENT_SWEETLAKE} from "../../AppConstants.js";
import * as booking_select from "../booking/booking.scenarios.select.svelte.js"
import DataUtil from "../../utils/DataUtil";
import {debug} from "../debug/feature.debug.svelte.js";
import * as progress_select from "./progress.scenarios.select.svelte.js"

export function getPrevStepNr()
{
  let bIsSweetLake = progress.sEnvironmentID === ENVIRONMENT_SWEETLAKE;
  const aSteps = progress.aSteps;
  let iCurrentVisibleStep = progress.iCurrentVisibleStep;
  const bHidePackageDeals = progress_select.isPackageDealBlockHidden();

  if ( iCurrentVisibleStep === 0 )
  {
    iCurrentVisibleStep = progress.iHighestShownStep;
  }

  if ( iCurrentVisibleStep === progress.aSteps[0] )
  {
    return false;
  }

  let iIndexOfNextStep = -1;
  let iPrevStepIndex = 0;
  for ( let i = 0; i < aSteps.length; ++i )
  {
    if ( aSteps[i] === iCurrentVisibleStep )
    {
      // dan is de vorige de goede tenzij de vorige arrangementen is en we die niet tonen
      iIndexOfNextStep = iPrevStepIndex;
      break;
    }

    iPrevStepIndex = i;
  }


  if ( iIndexOfNextStep === -1 )
  {
    // niks gevonden.. dat is errorig
    return false;
  }

  // Eventuele correcties
  if ( iCurrentVisibleStep === 20 && booking.iFixedNrOfPeople !== false )
  { // als het aantal personen vaststaat dan heeft het geen zin om die stap te tonen
    iIndexOfNextStep = iIndexOfNextStep - 1;
  }
  else if ( iCurrentVisibleStep === 17 && (booking.sStep10CategoryChoice === 'arrangement') )
  { // Arrangement slaat Step14 over, dus ook terug (en Sweetlake op het moment voor alles)
    iIndexOfNextStep = iIndexOfNextStep - 1;
  }
  else if ( iCurrentVisibleStep === 50 && bHidePackageDeals )
  {
    iIndexOfNextStep = iPrevStepIndex - 1;
  }

  return typeof aSteps[iIndexOfNextStep] !== "undefined" ? aSteps[iIndexOfNextStep] : false;
} // eof getPrevStepNr

export function getNextStepNr()
{
  let bIsSweetLake = progress.sEnvironmentID === ENVIRONMENT_SWEETLAKE;
  const aSteps = progress.aSteps;
  let iCurrentVisibleStep = progress.iCurrentVisibleStep;
  const bHidePackageDeals = progress_select.isPackageDealBlockHidden();

  if ( iCurrentVisibleStep === 0 )
  {
    iCurrentVisibleStep = progress.iHighestShownStep;
  }

  let iIndexOfNextStep = -1;
  let bCurrentFound = false;
  for ( let i = 0; i < aSteps.length; ++i )
  {
    if ( bCurrentFound )
    {
      iIndexOfNextStep = i;
      break;
    }

    if ( aSteps[i] === iCurrentVisibleStep ) bCurrentFound = true;
  }

  if ( iIndexOfNextStep === -1 )
  {
    // niks gevonden.. dat is errorig
    return false;
  }

  // Eventuele correcties
  if ( iCurrentVisibleStep === 10 && (booking.sStep10CategoryChoice === 'arrangement') )
  { // Arrangement slaat Step14 over
    iIndexOfNextStep = iIndexOfNextStep + 1;
  }
  else if ( iCurrentVisibleStep === 14 && booking.iFixedNrOfPeople !== false )
  { // als het aantal personen vaststaat dan heeft het geen zin om Step17 te tonen
    iIndexOfNextStep = iIndexOfNextStep + 1;
  }
  else if ( iCurrentVisibleStep === 30 && bHidePackageDeals )
  {
    iIndexOfNextStep = iIndexOfNextStep + 1;
  }

  return typeof aSteps[iIndexOfNextStep] !== "undefined" ? aSteps[iIndexOfNextStep] : false;
} // eof getNextStepNr

export function isPackageDealBlockHidden()
{
  return !booking.bShowListOfPackageDeals;
}

export function isDebugModeEnabled()
{
  return progress.bIsDebugModeEnabled;
}

export function getValidationReport()
{
  progress_select.resetNewMoveToAllowedReport();

  if ( booking.lPeople.length === 0 )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL17_PEOPLE].push("iNrOfPeople");
  }

  if ( typeof booking.sArrivalDate !== "string" )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL20_CALENDAR].push("sArrivalDate");
  }

  if ( !booking.iArrivalTime )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL30_TIME].push("iArrivalTime");
  }

  if ( !booking.iDepartureTime )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL30_TIME].push("iDepartureTime");
  }

  const oSelectedPackageDeal = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();
  const bIsPackageDealBlockHidden = progress_select.isPackageDealBlockHidden();
  if ( !bIsPackageDealBlockHidden && !oSelectedPackageDeal )
  {
    // dit gebruikten we om te forceren dat je een arrangement MOET kiezen - voor nu uit
    //progress.oValidationReport.aIncorrectFields[UI_ID_PANEL40_PACKAGEDEAL].push("sNonExistentPackageDealComponent");
  }

  const oPackageDealChoicesReport = booking_select.getPackageDealChoicesStatusReport();
  if ( oPackageDealChoicesReport?.aPeople )
  {
    //console.log('Validatiecheck 2', $state.snapshot(oPackageDealChoicesReport));
    for ( const [sPersonID, aPersonInfo] of Object.entries(oPackageDealChoicesReport.aPeople) )
    {

      for ( const oChoiceSet of oPackageDealChoicesReport.aProductGroupsThatAreOptionInPackageDeal )
      {

        if ( !aPersonInfo[`c${oChoiceSet.iChoiceID}`] )
        {
          const sComponentName = `p${sPersonID}c${oChoiceSet.iChoiceID}`;
          // dit was in de behandelingstap, maar gaat nu naar de arrangementstap er voor
          //progress.oValidationReport.aIncorrectFields[UI_ID_PANEL50_TREATMENTS].push(sComponentName);
          progress.oValidationReport.aIncorrectFields[UI_ID_PANEL40_PACKAGEDEAL].push(sComponentName);
        }
      }
    }
  }

  if ( !DataUtil.isValidEmail(booker.sEmail) )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sEmail");
  }

  if ( !booker.sName1 )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sName1");
  }

  if ( !booker.sName3 )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sName3");
  }

  if ( !booker.sTel )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sTel");
  }

  if ( !booker.sPostalcode )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sPostalcode");
  }

  if ( !booker.sHouse1 )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sHouse1");
  }

  if ( !booker.sStreet )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sStreet");
  }

  if ( !booker.sTown )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sTown");
  }

  if ( !booker.bTerms && !booker.iRelationID )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("bTerms");
  }

  // Badenkaart validatie: niet door als badenkaart geselecteerd maar niet ingelogd
  if ( booking.sSelectedEntryType === ENTRY_TYPE_BADENKAART &&
    booker.iRelationID === false )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sBadenkaartLoginRequired");
  }

  // Badenkaart validatie: niet door als dag-badenkaart geselecteerd maar geen credits
  if ( booking.sSelectedEntryType === ENTRY_TYPE_BADENKAART &&
    booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY &&
    booker.iRelationID !== false &&
    booker.bHasBadenkaartDayCredit === false )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sBadenkaartNoDayCredits");
  }

  // Badenkaart validatie: niet door als kort-badenkaart geselecteerd maar geen credits
  if ( booking.sSelectedEntryType === ENTRY_TYPE_BADENKAART &&
    booking.sPreferredPartOfTheDay === ENTRY_DURATION_2_HOUR &&
    booker.iRelationID !== false &&
    booker.bHasBadenkaartShortCredit === false )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].push("sBadenkaartNoShortCredits");
  }

  if ( !booker.sPaymentMethod )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL70_PAY].push("sPaymentMethod");
  }

  if ( booking_select.getAllBookedProducts(true, true, true).length === 0 && !oSelectedPackageDeal )
  {
    progress.oValidationReport.aIncorrectFields[UI_ID_PANEL70_PAY].push("sNonExistingNoProductsField");
  }

  // EVALUEREND:
  let bWasPrevStepAllowed = true;
  let bWasThereAnEarlierDisallowedStep = false;
  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL10_RESTYPE].length === 0 )
  {
    progress.oValidationReport.aAllowedSteps.push(14);
    if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 14;
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL14_RESSUBTYPE].length === 0 )
  {
    progress.oValidationReport.aAllowedSteps.push(17);
    if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 17;
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL17_PEOPLE].length === 0 )
  {
    progress.oValidationReport.aAllowedSteps.push(20);
    if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 20;
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL20_CALENDAR].length === 0 )
  {
    if ( bWasThereAnEarlierDisallowedStep === false )
    {
      progress.oValidationReport.aAllowedSteps.push(30);
      if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 30;
    }
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL30_TIME].length === 0 )
  {
    if ( bWasThereAnEarlierDisallowedStep === false )
    {
      progress.oValidationReport.aAllowedSteps.push(40);
      if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 40;
    }
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL40_PACKAGEDEAL].length === 0 )
  {
    if ( bWasThereAnEarlierDisallowedStep === false )
    {
      progress.oValidationReport.aAllowedSteps.push(50);
      if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 50;
    }
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL50_TREATMENTS].length === 0 )
  {
    if ( bWasThereAnEarlierDisallowedStep === false )
    {
      progress.oValidationReport.aAllowedSteps.push(60);
      if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 60;
    }
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL60_FORM].length === 0 )
  {
    if ( bWasThereAnEarlierDisallowedStep === false )
    {
      progress.oValidationReport.aAllowedSteps.push(70);
      if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 80;
    }
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  // stap 70 betaling

  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL70_PAY].length === 0 )
  {
    if ( bWasThereAnEarlierDisallowedStep === false )
    {
      progress.oValidationReport.aAllowedSteps.push(80); // 80 is insturen naar de server
      if ( bWasPrevStepAllowed ) progress.oValidationReport.iHighestStepWithoutValidationErrors = 80;
    }
  }
  else
  {
    bWasThereAnEarlierDisallowedStep = true;
    bWasPrevStepAllowed = false;
  }

  if ( debug.bAreHMKDevToolsActive )
  {
    debug.oLatestIsMoveAllowedReport = progress.oValidationReport;
  }


  return progress.oValidationReport;
}

export function resetNewMoveToAllowedReport()
{
  progress.oValidationReport.aAllowedSteps = [10];
  progress.oValidationReport.aIncorrectFields = {
    [UI_ID_PANEL10_RESTYPE]: [],
    [UI_ID_PANEL14_RESSUBTYPE]: [],
    [UI_ID_PANEL17_PEOPLE]: [],
    [UI_ID_PANEL20_CALENDAR]: [],
    [UI_ID_PANEL30_TIME]: [],
    [UI_ID_PANEL40_PACKAGEDEAL]: [],
    [UI_ID_PANEL50_TREATMENTS]: [],
    [UI_ID_PANEL60_FORM]: [],
    [UI_ID_PANEL70_PAY]: []
  };
}

export function getStepsToShowValidationFor()
{
  const aResponse = [];
  const iHighestAttemptedStep = progress.iHighestAttemptedStep;
  const aSteps = progress.aSteps;

  aSteps.forEach((iStepNr) => {
    if ( iHighestAttemptedStep > iStepNr ) aResponse.push(iStepNr);
  });

  return aResponse;
}

export function shouldWeDisplayValidationForPanel(sPanelID = false)
{
  if ( !sPanelID ) return false;

  const iStepNrForPanel = progress_select.getStepNrForPanelID(sPanelID);
  const aStepsToShowValidationFor = progress_select.getStepsToShowValidationFor();

  return aStepsToShowValidationFor.includes(iStepNrForPanel);
}

export function getStepNrForPanelID(sPanelID)
{
  let iStepNr = false;
  switch ( sPanelID )
  {
    case UI_ID_PANEL10_RESTYPE:
      iStepNr = 10;
      break;
    case UI_ID_PANEL14_RESSUBTYPE:
      iStepNr = 14;
      break;
    case UI_ID_PANEL17_PEOPLE:
      iStepNr = 17;
      break;
    case UI_ID_PANEL20_CALENDAR:
      iStepNr = 20;
      break;
    case UI_ID_PANEL30_TIME:
      iStepNr = 30;
      break;
    case UI_ID_PANEL40_PACKAGEDEAL:
      iStepNr = 40;
      break;
    case UI_ID_PANEL50_TREATMENTS:
      iStepNr = 50;
      break;
    case UI_ID_PANEL60_FORM:
      iStepNr = 60;
      break;
    case UI_ID_PANEL70_PAY:
      iStepNr = 70;
      break;
  }

  return iStepNr;
}


